import { useNumberBooleanChoices } from 'hooks/useNumberBooleanChoices';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { AutocompleteArrayInput, AutocompleteInput, TextInput } from 'shared/react-admin/Inputs';
import { ReferenceArrayInput, ReferenceInput } from 'shared/react-admin/ReferenceInputs';
import { Currency } from 'types/embedded/currency';
import { Merchant } from 'types/embedded/merchant';

export const MerchantShowAccountsFiltersTable = () => {
  const translate = useTypedTranslate();

  const record = useRecordContext<Merchant>();
  const numberBooleanChoices = useNumberBooleanChoices();

  const { watch, resetField } = useFormContext();

  const providerWatched = watch('provider');

  return (
    <>
      <TextInput
        helperText={false}
        key="name"
        label={translate('app.filter.name')}
        name="name"
        source="name"
        variant="outlined"
      />
      <ReferenceInput
        filter={{ merchantAccounts: { merchants: record?.id } }}
        isFilter={true}
        name="provider"
        perPage={200}
        reference="providers"
        sort={{ field: 'name', order: 'ASC' }}
        source="provider"
      >
        <AutocompleteInput
          clearOnBlur={false}
          filterToQuery={(searchText: string) => ({ name: searchText })}
          helperText={false}
          label={translate('app.filter.provider')}
          name="provider"
          onChange={() => {
            resetField('gateways', { keepDirty: true });
          }}
          optionText="name"
          variant="outlined"
        />
      </ReferenceInput>
      <ReferenceInput
        filter={{ merchantAccounts: { merchants: record?.id }, provider: providerWatched }}
        isFilter={true}
        name="gateways"
        perPage={200}
        reference="gateways"
        source="gateways"
      >
        <AutocompleteInput
          clearOnBlur={false}
          filterToQuery={(searchText: string) => ({ name: searchText })}
          helperText={false}
          label={translate('app.filter.gateway')}
          name="gateways"
          optionText="name"
          variant="outlined"
        />
      </ReferenceInput>
      <ReferenceArrayInput
        filter={{ active: true }}
        perPage={1000}
        reference="currencies"
        sort={{ field: 'id', order: 'ASC' }}
        source="currency"
      >
        <AutocompleteArrayInput
          clearOnBlur={false}
          filterToQuery={(searchText: string) => ({ currency: searchText })}
          helperText={false}
          label={translate('app.filter.currencies')}
          name="currency"
          optionText={(record: Currency) => `${record?.alphaCode}, ${record?.name}`}
          size="small"
          variant="outlined"
        />
      </ReferenceArrayInput>
      <AutocompleteInput
        choices={numberBooleanChoices}
        label={translate('app.filter.partners')}
        name="partner"
        optionText="label"
        variant="outlined"
      />
    </>
  );
};
